import { FilesApiDatasource } from '../data/datasources/files-api.datasource';
import { FilesRepositoryImpl } from '../data/repositories/files.repository.impl';

const api = new FilesApiDatasource();
const repository = new FilesRepositoryImpl(api);

export const filesContainer = { repository };
